/* JVD PROPIEDADES — interacciones del sitio */
(function () {
  'use strict';
  var d = document;

  /* ---------- Encabezado y menú móvil ---------- */
  var hdr = d.querySelector('[data-header]');
  var toggle = d.querySelector('[data-menu-toggle]');
  function onScroll() { if (hdr) hdr.classList.toggle('is-scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  function closeMenu() {
    if (!hdr || !toggle) return;
    hdr.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.querySelector('.sr').textContent = 'Abrir menú';
  }
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = !hdr.classList.contains('is-open');
      hdr.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.querySelector('.sr').textContent = open ? 'Cerrar menú' : 'Abrir menú';
    });
    d.querySelectorAll('[data-nav] a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  }

  /* ---------- Animaciones de entrada ---------- */
  var reveals = d.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Utilidades de precio ---------- */
  function toNumber(v) { return parseInt(String(v || '').replace(/[^0-9]/g, ''), 10) || 0; }
  function fmt(n) { return n ? n.toLocaleString('es-CL') : ''; }
  d.querySelectorAll('[data-money]').forEach(function (inp) {
    inp.addEventListener('input', function () {
      var n = toNumber(inp.value);
      inp.value = n ? fmt(n) : '';
    });
  });

  /* ---------- Buscador de la portada: limpia campos vacíos al enviar ---------- */
  d.querySelectorAll('form.search:not([data-live-filters])').forEach(function (f) {
    f.addEventListener('submit', function () {
      f.querySelectorAll('[data-money]').forEach(function (i) { i.value = toNumber(i.value) || ''; });
      Array.prototype.forEach.call(f.elements, function (el) {
        if (el.name && !el.value && el.type !== 'radio') el.disabled = true;
        if (el.type === 'radio' && el.checked && !el.value) el.disabled = true;
      });
      setTimeout(function () { Array.prototype.forEach.call(f.elements, function (el) { el.disabled = false; }); }, 500);
    });
  });

  /* ---------- Filtros del catálogo ---------- */
  var live = d.querySelector('[data-live-filters]');
  var grid = d.querySelector('[data-grid]');
  if (live) {
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.pcard')) : [];
    var results = d.querySelector('[data-results]');
    var empty = d.querySelector('[data-empty]');
    var ubic = live.querySelector('[data-ubic]');

    // Agrega al filtro de ubicación las comunas que existan en las propiedades publicadas
    var labels = {};
    cards.forEach(function (c) {
      var v = c.dataset.comuna; if (!v) return;
      var loc = c.querySelector('.pcard__loc');
      var txt = loc ? loc.textContent.split(',').pop().trim() : v;
      labels[v] = txt;
    });
    Object.keys(labels).forEach(function (v) {
      if (ubic && !ubic.querySelector('option[value="' + v + '"]')) {
        var o = d.createElement('option'); o.value = v; o.textContent = labels[v];
      }
    });

    // Rellena los filtros desde la URL (búsqueda enviada desde la portada)
    var params = new URLSearchParams(location.search);
    ['tipo', 'ubic', 'dorm', 'banos', 'orden'].forEach(function (k) {
      var el = live.elements[k]; if (el && params.get(k)) el.value = params.get(k);
    });
    ['pmin', 'pmax'].forEach(function (k) {
      var el = live.elements[k]; if (el && params.get(k)) el.value = fmt(toNumber(params.get(k)));
    });
    if (params.get('op')) {
      var r = live.querySelector('input[name="op"][value="' + params.get('op') + '"]');
      if (r) r.checked = true;
    }

    function apply(updateUrl) {
      var f = live.elements;
      var op = (live.querySelector('input[name="op"]:checked') || {}).value || '';
      var tipo = f.tipo.value, u = f.ubic.value;
      var pmin = toNumber(f.pmin.value), pmax = toNumber(f.pmax.value);
      var dorm = toNumber(f.dorm.value), banos = toNumber(f.banos.value);
      var orden = f.orden ? f.orden.value : '';
      var shown = 0;

      cards.forEach(function (c) {
        var precio = toNumber(c.dataset.precio);
        var ok = (!op || c.dataset.op === op) &&
          (!tipo || c.dataset.tipo === tipo) &&
          (!u || c.dataset.comuna === u) &&
          (!pmin || precio >= pmin) &&
          (!pmax || (precio > 0 && precio <= pmax)) &&
          (!dorm || toNumber(c.dataset.dorm) >= dorm) &&
          (!banos || toNumber(c.dataset.banos) >= banos);
        c.classList.toggle('is-hidden', !ok);
        if (ok) { shown++; c.classList.add('is-in'); }
      });

      var sorted = cards.slice();
      if (orden === 'precio-asc') sorted.sort(function (a, b) { return toNumber(a.dataset.precio) - toNumber(b.dataset.precio); });
      else if (orden === 'precio-desc') sorted.sort(function (a, b) { return toNumber(b.dataset.precio) - toNumber(a.dataset.precio); });
      else sorted.sort(function (a, b) { return toNumber(b.dataset.orden) - toNumber(a.dataset.orden); });
      if (grid) sorted.forEach(function (c) { grid.appendChild(c); });

      if (results) results.textContent = shown === 1 ? '1 propiedad encontrada' : shown + ' propiedades encontradas';
      if (empty) empty.hidden = shown > 0;

      if (updateUrl && window.history && history.replaceState) {
        var q = new URLSearchParams();
        if (op) q.set('op', op);
        if (tipo) q.set('tipo', tipo);
        if (u) q.set('ubic', u);
        if (pmin) q.set('pmin', pmin);
        if (pmax) q.set('pmax', pmax);
        if (dorm) q.set('dorm', dorm);
        if (banos) q.set('banos', banos);
        if (orden) q.set('orden', orden);
        var s = q.toString();
        history.replaceState(null, '', location.pathname + (s ? '?' + s : ''));
      }
    }

    live.addEventListener('change', function () { apply(true); });
    live.addEventListener('input', function (e) { if (e.target.matches('[data-money]')) apply(true); });
    live.addEventListener('submit', function (e) { e.preventDefault(); apply(true); });
    live.addEventListener('reset', function () { setTimeout(function () { apply(true); }, 0); });
    apply(false);
  }

  /* ---------- Galería de la ficha ---------- */
  d.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-slide]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    var count = g.querySelector('[data-count]');
    if (slides.length < 2) return;
    var i = 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== i; s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      var img = slides[i].querySelector('img'); if (img) img.loading = 'eager';
    }
    var prev = g.querySelector('[data-prev]'), next = g.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
    var main = g.querySelector('.gallery__main'), x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    });
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(i - 1);
      if (e.key === 'ArrowRight') go(i + 1);
    });
  });

  /* ---------- Compartir propiedad ---------- */
  d.querySelectorAll('[data-share]').forEach(function (b) {
    var msg = d.querySelector('[data-share-msg]');
    b.addEventListener('click', function () {
      var data = { title: b.dataset.title, text: 'Mira esta propiedad de JVD Propiedades', url: b.dataset.url };
      if (navigator.share) {
        navigator.share(data).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(data.url).then(function () {
          if (msg) msg.textContent = 'Enlace copiado. Ya puedes pegarlo donde quieras.';
        }, function () { if (msg) msg.textContent = data.url; });
      } else if (msg) {
        msg.textContent = data.url;
      }
    });
  });

  /* ---------- Formularios: validación y estados reales ---------- */
  var MSG = {
    valueMissing: 'Este campo es obligatorio.',
    typeMismatch: 'Ingresa un correo válido (ej.: nombre@correo.cl).',
    patternMismatch: 'Ingresa un teléfono válido (ej.: +56 9 1234 5678).',
    tooShort: 'El texto es demasiado corto.'
  };
  function errFor(el) {
    var v = el.validity;
    if (v.valueMissing) return MSG.valueMissing;
    if (v.typeMismatch) return MSG.typeMismatch;
    if (v.patternMismatch) return MSG.patternMismatch;
    if (v.tooShort) return MSG.tooShort;
    return '';
  }
  function check(el) {
    var field = el.closest('.field'); if (!field) return true;
    var out = field.querySelector('.field__err');
    var m = errFor(el);
    field.classList.toggle('is-invalid', !!m);
    el.setAttribute('aria-invalid', m ? 'true' : 'false');
    if (out) out.textContent = m;
    return !m;
  }

  var forms = d.querySelectorAll('form.lead-form');
  var hash = (location.hash || '').replace('#', '');
  var posted = /contact_posted=true/.test(location.search);
  var lastForm = null;
  try { lastForm = sessionStorage.getItem('jv-last-form'); } catch (e) {}

  forms.forEach(function (f) {
    f.noValidate = true;
    var fields = f.querySelectorAll('input:not([type=hidden]), select, textarea');
    fields.forEach(function (el) {
      el.addEventListener('blur', function () { if (el.value) check(el); });
      el.addEventListener('input', function () { if (el.closest('.field.is-invalid')) check(el); });
    });
    f.addEventListener('submit', function (e) {
      var firstBad = null;
      fields.forEach(function (el) { if (!check(el) && !firstBad) firstBad = el; });
      if (firstBad) { e.preventDefault(); firstBad.focus(); return; }
      f.classList.add('is-sending');
      var btn = f.querySelector('button[type=submit]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      try { sessionStorage.setItem('jv-last-form', f.id); } catch (err) {}
    });

    // Muestra el mensaje de éxito solo en el formulario que realmente se envió
    var ok = f.querySelector('[data-form-ok]');
    var err = f.querySelector('[data-form-err]');
    var mine = hash === f.id || (!hash && lastForm === f.id) || (!hash && !lastForm);
    if (ok && posted && mine) {
      ok.hidden = false;
      setTimeout(function () { f.scrollIntoView({ block: 'center' }); }, 300);
    }
    if (err && !mine && (hash || lastForm)) err.hidden = true;
  });
  if (posted) { try { sessionStorage.removeItem('jv-last-form'); } catch (e) {} }
})();
